export interface SavedQuery {
  name: string;
  body: string;
}

const KEY = 'rb_admin_saved_queries';

export function listSavedQueries(): SavedQuery[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (q): q is SavedQuery => typeof q?.name === 'string' && typeof q?.body === 'string'
    );
  } catch {
    return [];
  }
}

function persist(list: SavedQuery[]): SavedQuery[] {
  localStorage.setItem(KEY, JSON.stringify(list));
  return list;
}

export function saveQuery(name: string, body: string): SavedQuery[] {
  const list = listSavedQueries().filter((q) => q.name !== name);
  list.push({ name, body });
  return persist(list);
}

export function deleteSavedQuery(name: string): SavedQuery[] {
  return persist(listSavedQueries().filter((q) => q.name !== name));
}
